import React from 'react'
import { connect } from 'react-redux'
import { Switch, Route } from 'react-router-dom'
import { Project } from '@leverege/api-redux'
import { Content, TabPane, Flex, Button, Toast, Text } from '@leverege/ui-elements'

import { BreadcrumbActions } from '../../actions'

import RoleScreen from './RoleScreen'
import PermissionScreen from './PermissionScreen'
import RoleModel from './RoleModel'
import RoleEditor from './RoleEditor'
import ModuleModel from './ModuleModel'
import ModuleEditor from './ModuleEditor'
import AddDialog from './AddDialog'

const routes = [
  <Route key="/project/:projectId/authz/role" 
    path={[ 
      '/project/:projectId/authz/role/:roleId', 
      '/project/:projectId/authz/role' 
    ]}
    component={RoleScreen} />,
  <Route key="/project/:projectId/authz/permission" 
    path={[ 
      '/project/:projectId/authz/permission/:permissionId', 
      '/project/:projectId/authz/permission'
    ]}
    component={PermissionScreen} />
]

class AuthzScreen extends React.Component {

  constructor( props ) {
    super( props )
    this.state = { showAdd : false, addType : null, activeTab : 'role' }
  }

  static getDerivedStateFromProps( props, state ) {
    const isRole = props.location.pathname.indexOf( 'authz/role' ) >= 0
    const activeTab = isRole ? 'role' : 'permission'
    if ( state.activeTab !== activeTab ) {
      return { activeTab }
    }
    return null
  }

  componentDidMount() {
    const { match, dispatch, history } = this.props
    const { projectId, roleId } = match.params
    const prj = new Project( projectId )
    dispatch( Project( projectId ).roles().list() )
    dispatch( Project( projectId ).modules().list() )
    dispatch( Project( projectId ).permissions().list() )

    dispatch( Project( 'imagine' ).roles().list() )
    dispatch( Project( 'imagine' ).modules().list() )
    dispatch( Project( 'imagine' ).permissions().list() )

    this.props.dispatch( BreadcrumbActions.setBreadcrumbs( [ { name : 'Roles' } ] ) )
  }

  onAdd = ( evt ) => {
    this.setState( { showAdd : true, addType : evt.data } )    
  }

  onClose = ( evt ) => {
    this.setState( { showAdd : false } )    
  }
  
  onAddRole = ( role ) => {
    const { dispatch, match, history } = this.props
    const { scope, ...rest } = role
    const projectId = match.params.projectId
    this.onClose()
    dispatch( Project( projectId )
      .roles()
      .create( rest ) )
      .then( ( data ) => {
        history.push( `/project/${projectId}/authz/role/${data.id}` )
      }, 
      ( err ) => {
        console.log( 'err', err )
        const msg = (
          <div>
            <Text variant="toastTitle">Role Creation Failed</Text>
            <Text variant="toastMsg">{err.message}</Text>
          </div>
        )
        Toast.error( msg, { } )
      }
      )
  }

  onAddModule = ( role ) => {
    const { dispatch, match, history } = this.props
    const { scope, ...rest } = role
    const projectId = match.params.projectId
    this.onClose()
    dispatch( Project( projectId )
      .modules()
      .create( rest ) )
      .then( ( data ) => {
        history.push( `/project/${projectId}/authz/permission/${data.projectId}-${data.name}` )
      }, 
      ( err ) => {
        console.log( 'err', err )
        const msg = (
          <div>
            <Text variant="toastTitle">Module Creation Failed</Text>
            <Text variant="toastMsg">{err.message}</Text>
          </div>
        )
        Toast.error( msg, { } )
      }
      )
  }

  onTabClicked = ( event ) => { 
    const { history, match } = this.props
    history.push( `/project/${match.params.projectId}/authz/${event.value}` )
    this.setState( { activeTab : event.value } )
  }

  render() {
    const { showAdd, addType, activeTab } = this.state

    return (
      <Content>
        <Content.Header>  
          <Flex style={{ padding : '10px 20px' }} variant="rowM" justify="space-between" >
            <Text variant="screenTitle" >Roles / Actions</Text>
            <Flex variant="rowM">
              <Button onClick={this.onAdd} eventData="role">Create Role</Button>
              <Button onClick={this.onAdd} eventData="module">Create Module</Button>
            </Flex>
          </Flex>
          <TabPane activeId={activeTab} onTabClicked={this.onTabClicked}>
            <TabPane.Tab tabName="Roles" tabId="role" />
            <TabPane.Tab tabName="Permissions" tabId="permission" />
          </TabPane>
        </Content.Header>
        <Content.Area>
          <Switch>
            {routes}
          </Switch>
        </Content.Area>
        <Content.Footer>
          <AddDialog 
            title="Create Role"
            editor={RoleEditor}
            creator={RoleModel}
            onClose={this.onClose} 
            onCreate={this.onAddRole} 
            show={showAdd && addType === 'role'}/>
          <AddDialog 
            title="Create Module"
            editor={ModuleEditor}
            creator={ModuleModel}
            onClose={this.onClose} 
            onCreate={this.onAddModule} 
            show={showAdd && addType === 'module'}/>
        </Content.Footer>
      </Content>
    )
  }
}

export default connect(
  state => ( {
    systems : state.systems
  } )
)( AuthzScreen )
